/**
 * Selector de continente de los listados sin mapa.
 *
 * Lo usan el bloque de representantes (block_section_repres) y el de tiendas online
 * (block_section_online_stores): un select que enseña el contenedor de su continente y esconde
 * el resto.
 *
 * Vive aparte de store-locator.js porque ese bundle depende de Mapbox GL (1,5 MB) y estas dos
 * páginas no tienen mapa: se lo estaban descargando para no usarlo.
 */
(function($) {

    const FindYourRep = {
        init: function(){
            const select = $('#wtb-find-rep-continent');

            if(select.length === 0) return;

            /* El 'change' es la red por si select2 no llegara a inicializarse: sin él el select
               nativo no hacía nada */
            select.on('select2:select change', (event) => {
                const option = event.params?.data ?? {
                    id: select.val(),
                    text: select.find('option:selected').text()
                };

                if(!option.id) return;

                $('h4.continent-name').text((option.text ?? '').trim());
                $('.container-continent').addClass('hidden');
                /* El id sale de sanitize_title() en PHP, pero se escapa igual antes de meterlo
                   en un selector */
                $(document.getElementById(option.id)).removeClass('hidden');
            });
        }
    };

    $(document).ready(() => FindYourRep.init());

})(window.jQuery);
